import(/* webpackMode: "eager", webpackExports: ["ShareButtons"] */ "/tmp/8de698b5c6a30cb/components/blog/ShareButtons.tsx");
;
import(/* webpackMode: "eager" */ "/tmp/8de698b5c6a30cb/components/ui/Container.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8de698b5c6a30cb/components/ui/Section.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8de698b5c6a30cb/components/ui/Button.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8de698b5c6a30cb/components/blog/BlogCard.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8de698b5c6a30cb/components/ui/Heading.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8de698b5c6a30cb/components/blog/RelatedPosts.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8de698b5c6a30cb/app/[locale]/blog/[slug]/page.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8de698b5c6a30cb/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/tmp/8de698b5c6a30cb/node_modules/next/dist/client/link.js");
